<template>
  <v-dialog v-model="commentDialog" width="850">
    <v-card>
      <!-- <pre>{{articledata}}s</pre> -->
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <span class="display-1 text-uppercase font-weight-bold">Kommentar</span>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          title="Lukk vindu"
          class="ma-2"
          outlined
          icon
          large
          @click="closeDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col md="12 pt-0">
            <v-textarea
              outlined
              auto-grow
              v-model="commentData.Content"
              rows="5"
              label="Comment"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="submitComment">Submit comment</v-btn>
        <v-btn color="warning" @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import messages from "../modules/lang/export";
import { mapActions } from "vuex";

export default {
  i18n: { messages },
  data() {
    return {
      commentDialog: false,
      reasons: ["Duplicate", "Harrasment", "Breaking ToS"],
      commentData: {
        Content: "",
        Articles_id: "",
        ArticleComments_id: null
      }
    };
  },
  watch: {
    commentDialog(newVal) {
      if (newVal === false) {
        this.commentData.Content = "";
        this.commentData.Articles_id = "";
        this.commentData.ArticleComments_id = null;
      }
    }
  },
  methods: {
    ...mapActions(["POST_COMMENT"]),
    submitComment() {
      let _CommentObject = {
        Articles_id: this.commentData.Articles_id,
        Content: this.commentData.Content,
        ArticleComments_id: this.commentData.ArticleComments_id || null
      };

      this.POST_COMMENT(_CommentObject)
        .then(res => {
          alert("Your comment is received");
          this.$emit("updatearticle");
          this.commentDialog = false;
        })
        .catch(err => {
          alert("Sorry, an error occured. Your report may not be saved.");
          this.commentDialog = false;
        });
    },
    // Opening the dialog through the ref
    openDialog(incomingData) {
      if (incomingData) {
        this.commentData = Object.assign({}, this.commentData, incomingData);
      }
      this.commentDialog = true;
    },
    closeDialog() {
      this.commentDialog = false;
    }
  }
};
</script>
